import React, { useState, useEffect, useRef } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

//icons
import ChevronRight from "@material-ui/icons/ChevronRight";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import SaveIcon from "@material-ui/icons/Save";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";

import useStyles from "./styles";

import { usePouchDB } from "../../../../components/PouchDB/PouchDBProvider";
import { useSnackbar } from "notistack";

import { Swipeable } from "react-swipeable";

import { countAge } from "../pk/validation";

// subforms

import SubForm01 from "./subforms/01";
import SubForm02 from "./subforms/02";
import SubForm03 from "./subforms/03";
import SubForm04 from "./subforms/04";
import SubForm05 from "./subforms/05";
import SubForm06 from "./subforms/06";
import SubForm07 from "./subforms/07";
import SubForm08 from "./subforms/08";
import SubForm09 from "./subforms/09";
import { parse } from "crypto-js/enc-utf8";
// import SubForm10 from './subforms/10';
const subforms = {
  "0101": {
    component: SubForm01,
  },
  "0102": {
    component: SubForm02,
  },
  "0103": {
    component: SubForm03,
  },
  "0104": {
    component: SubForm04,
  },
  "0105": {
    component: SubForm05,
  },
  "0106": {
    component: SubForm06,
  },
  "0107": {
    component: SubForm07,
  },
  "0108": {
    component: SubForm08,
  },
  "0109": {
    component: SubForm09,
    // }, "0110": {
    //     component: SubForm10
  },
};

function KB({
  wilayah,
  keluarga,
  kb,
  mainSlide,
  setKB,
  handleNext,
  handleBack,
  handleDraft,
  handleSegmen,
  handleBackSegmen,
  handleNextSegmen,
  handleAnomali,
  setNormalizeKB,
  mode,
  no_kk,
}) {
  const classes = useStyles();
  const nextRef = useRef(null);
  const backRef = useRef(null);

  const {
    user: { metadata },
  } = usePouchDB();
  const { enqueueSnackbar } = useSnackbar();

  const [wifeExists, setWifeExists] = useState(false); //set false

  //action draft
  let valIndex = 0;
  if (
    wilayah.status_draft == 1 &&
    wilayah.pos_draft == 2 &&
    wilayah.subformIndex !== undefined
  ) {
    valIndex = wilayah.subformIndex;
  }

  //action notvalid
  if (wilayah.status_draft == 2 && wilayah.status_sensus == "NotValid") {
    const form_invalid = wilayah.form_invalid;
    if (form_invalid != "") {
      if (form_invalid === "kb") {
        if (wilayah.index_invalid === "") {
          valIndex = 0;
        } else {
          if (wilayah.index_invalid != 0) {
            valIndex = wilayah.index_invalid - 1;
          } else {
            valIndex = wilayah.index_invalid;
          }
        }
      }
    }
  }

  const [subformIndex, setSubFormIndex] = useState(valIndex);

  const [slide, setSlide] = useState({
    direction: "left",
    in: true,
  });

  const [isSomethingChange, setSomethingChange] = useState(false);

  const [isSubmitting, setSubmitting] = useState(false);

  const [isSaved, setSaved] = useState({
    local: false,
    remote: false,
  });

  const [navigationMode, setNavigationMode] = useState("next");

  useEffect(() => {
    const findWife = Object.values(keluarga).find((k) => {
      if (
        k.jenis_kelamin === "2" &&
        (k.sts_kawin === "2" || k.sts_kawin === "3") &&
        k.sts_hubungan === "2"
      ) {
        const age = countAge(k.tgl_lahir);
        return age >= 10 && age <= 49;
      }
      return false;
    });

    let initialKB = {};
    //action draft
    if (wilayah.status_draft == 1) {
      const sfKeys = Object.keys(subforms);
      if (wilayah.data_kb["0"] == null) {
        for (let i = 0; i < sfKeys.length; i++) {
          initialKB[`${sfKeys[i]}`] = {};
        }
      } else {
        for (let i = 0; i < sfKeys.length; i++) {
          initialKB[`${sfKeys[i]}`] = wilayah.data_kb[i];
        }
      }
    } else {
      //action edit
      if (mode == "edit") {
        const sfKeys = Object.keys(subforms);
        if (wilayah.data_kb["0"] == null) {
          for (let i = 0; i < sfKeys.length; i++) {
            initialKB[`${sfKeys[i]}`] = {};
          }
        } else {
          for (let i = 0; i < sfKeys.length; i++) {
            initialKB[`${sfKeys[i]}`] = wilayah.data_kb[i];
          }
        }
      } else {
        const sfKeys = Object.keys(subforms);
        for (let i = 0; i < sfKeys.length; i++) {
          initialKB[`${sfKeys[i]}`] = {};
        }
      }
    }

    //console.log("Initial KB nya : ", initialKB)

    if (findWife) {
      setKB((ckb) => {
        //console.log("CKB : ", ckb)
        if (Object.keys(ckb).length > 0) {
          return { ...initialKB, ...ckb };
        }
        return initialKB;
      });

      setNormalizeKB((ckb) => {
        if (Object.keys(ckb).length > 0) {
          return { ...initialKB, ...ckb };
        }
        return initialKB;
      });

      setWifeExists(true);

      if (mainSlide.navigationMode === "next") {
        setNavigationMode("next");
        if (
          wilayah.status_draft === 1 &&
          wilayah.pos_draft == 2 &&
          wilayah.subformIndex !== undefined
        ) {
          setSubFormIndex(subformIndex);
        } else {
          if (
            wilayah.status_draft === 2 &&
            wilayah.status_sensus === "NotValid"
          ) {
            const form_invalid = wilayah.form_invalid;
            if (form_invalid !== "") {
              if (form_invalid === "kb") {
                setSubFormIndex(valIndex);
              }
            }
          } else {
            setSubFormIndex(0);
          }
        }
      } else {
        setNavigationMode("back");
        if (
          wilayah.status_draft === 1 &&
          wilayah.pos_draft === 2 &&
          wilayah.subformIndex !== undefined
        ) {
          setSubFormIndex(subformIndex);
        } else {
          if (
            wilayah.status_draft === 2 &&
            wilayah.status_sensus === "NotValid"
          ) {
            const form_invalid = wilayah.form_invalid;
            if (form_invalid !== "") {
              if (form_invalid === "kb") {
                setSubFormIndex(valIndex);
              }
            }
          } else {
            setSubFormIndex(8);
          }
        }
      }
    } else {
      setKB(initialKB);
      setNormalizeKB(initialKB);
      if (mainSlide.navigationMode === "next") {
        handleNext();
      } else {
        handleBack();
      }
    }

    //console.log("KB Doang : ", kb)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!wifeExists) {
    return null;
  }

  const segmenValidate = () => {
    let newValidate = true;
    let message = "";

    //console.log("DATA KB : ", kb)

    // console.log(">>>", kb["0101"]);

    if (kb["0101"].kelahiran === "" || kb["0101"].kelahiran === undefined) {
      newValidate = false;
      message = `KB No.1 Jumlah Kelahiran Tidak Boleh Kosong`;
      enqueueSnackbar(message, { variant: "warning" });
    } else if (kb["0101"].kelahiran === "0") {
      message = `KB No.1 Jumlah Kelahiran Tidak Boleh Nol`;
      enqueueSnackbar(message, { variant: "warning" });
    } else if (parseInt(kb["0101"].kelahiran) > 0) {
      if (
        parseInt(kb["0101"].lahir_hidup_laki_laki) === 0 ||
        kb["0101"].lahir_hidup_laki_laki === undefined ||
        parseInt(kb["0101"].lahir_hidup_perempuan) === 0 ||
        kb["0101"].lahir_hidup_perempuan === undefined ||
        parseInt(kb["0101"].masih_hidup_laki_laki) === 0 ||
        kb["0101"].masih_hidup_laki_laki === undefined ||
        parseInt(kb["0101"].masih_hidup_perempuan) === 0 ||
        kb["0101"].masih_hidup_perempuan === undefined
      ) {
        message = `KB No.1 Lengkapi Data Anak Lahir Hidup dan Data Jumlah Anak Masih Hidup`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    if (
      kb["0102"].sedang_hamil === "" ||
      kb["0102"].sedang_hamil === undefined
    ) {
      newValidate = false;
      message = `KB No.2 Sedang Hamil Tidak Boleh Kosong`;
      enqueueSnackbar(message, { variant: "warning" });
    } else if (kb["0102"].sedang_hamil === "1") {
      if (
        kb["0102"].usia_kehamilan === undefined ||
        kb["0102"].usia_kehamilan === null
      ) {
        newValidate = false;
        message = `KB No.2 Usia Kehamilan Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      } else if (
        kb["0102"].sedang_hamil_ingin === null ||
        kb["0102"].sedang_hamil_ingin === undefined
      ) {
        newValidate = false;
        message = `KB No.2 Ingin Anak Lagi Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (kb["0102"].sedang_hamil === "2") {
      if (
        kb["0102"].ingin_anak === null ||
        kb["0102"].ingin_anak === undefined
      ) {
        newValidate = false;
        message = `KB No.2 Ingin Anak Lagi Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    // Validasi form KB No.3
    //harus kosong
    if (kb["0102"].sedang_hamil === "1") {
      if (kb["0103"].menggunakan_kontrasepsi !== undefined) {
        console.log("KB No.3 Harus Kosong");

        newValidate = false;
        message = `KB No.3 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    //tidak boleh kosong
    if (kb["0102"].sedang_hamil !== "1") {
      if (kb["0103"].menggunakan_kontrasepsi === undefined) {
        console.log("KB No.3 Harus diisi");

        newValidate = false;
        message = `KB No.3 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    // end Validasi form KB No.3

    // Validasi form KB No.4
    // harus kosong
    if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "1"
    ) {
      if (kb["0104"].pernah_menggunakan_kontrasepsi !== undefined) {
        console.log("KB No.4 Harus Kosong");

        newValidate = false;
        message = `KB No.4 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    //tidak boleh kosong

    if (
      kb["0102"].sedang_hamil === "1" &&
      kb["0102"].sedang_hamil_ingin === "1"
    ) {
      if (
        !kb["0104"] ||
        kb["0104"].sedang_menggunakan_kontrasepsi === undefined
      ) {
        newValidate = false;
        message = `KB No.4 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    if (
      kb["0102"].sedang_hamil !== "2" &&
      kb["0103"].menggunakan_kontrasepsi !== "1"
    ) {
      if (
        !kb["0104"] &&
        kb["0104"].pernah_menggunakan_kontrasepsi === undefined
      ) {
        console.log("KB No.4 Harus Diisi");

        newValidate = false;
        message = `KB No.4 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    // end Validasi form KB No.4

    // Validasi form KB No.5
    //harus kosong
    if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "1"
    ) {
      if (kb["0105"].alasan_tidak_kb !== undefined) {
        console.log("KB No.5 Harus Kosong");

        newValidate = false;
        message = `KB No.5 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    //tidak boleh kosong
    if (
      kb["0102"].sedang_hamil !== "2" &&
      kb["0103"].menggunakan_kontrasepsi !== "1"
    ) {
      if (kb["0105"].alasan_tidak_kb === undefined) {
        console.log("KB No.5 Harus Diisi");

        newValidate = false;
        message = `KB No.5 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    // end Validasi form KB No.5

    // Validasi form KB No.6
    // harus kosong
    if (
      kb["0102"].sedang_hamil === "1" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0106"].jenis_kontrasepsi !== undefined) {
        console.log("KB No.6 Harus Kosong =>", kb["0106"].jenis_kontrasepsi);

        newValidate = false;
        message = `KB No.6 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0106"].jenis_kontrasepsi !== undefined) {
        console.log("KB No.6 Harus Kosong =>>", kb["0106"].jenis_kontrasepsi);

        newValidate = false;
        message = `KB No.6 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    //tidak boleh kosong
    if (
      kb["0103"].menggunakan_kontrasepsi !== "1" &&
      (!kb["0104"] || kb["0104"].pernah_menggunakan_kontrasepsi === undefined)
    ) {
      newValidate = false;
      message = `KB No.4 Tidak Boleh Kosong`;
      enqueueSnackbar(message, { variant: "warning" });
    } else if (
      kb["0102"].sedang_hamil !== "1" &&
      kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
    ) {
      if (!kb["0105"] || kb["0105"].alasan_tidak_kb === undefined) {
        newValidate = false;
        message = `KB No.5 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
      if (kb["0106"].jenis_kontrasepsi === undefined) {
        newValidate = false;
        message = `KB No.6 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil !== "2" &&
      kb["0103"].menggunakan_kontrasepsi !== "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
    ) {
      if (kb["0106"].jenis_kontrasepsi === undefined) {
        newValidate = false;
        message = `KB No.6 Tidak Boleh Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    // end Validasi form KB No.6

    // Validasi form KB No.7
    //harus kosong
    if (kb["0106"].jenis_kontrasepsi === "9") {
      if (kb["0107"].tempat_pelayanan !== undefined) {
        console.log("KB No.7 Harus Kosong");

        newValidate = false;
        message = `KB No.7 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "1" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0107"].tempat_pelayanan !== undefined) {
        console.log("KB No.7 Harus Kosong");

        newValidate = false;
        message = `KB No.7 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0107"].tempat_pelayanan !== undefined) {
        console.log("KB No.7 Harus Kosong");

        newValidate = false;
        message = `KB No.7 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }
    //end

    // tidak boleh kosong
    if (
      kb["0106"].jenis_kontrasepsi !== "9" &&
      kb["0106"].jenis_kontrasepsi !== undefined
    ) {
      if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (kb["0107"].tempat_pelayanan === undefined) {
          console.log("KB No.7 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.7 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "1" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (kb["0107"].tempat_pelayanan === undefined) {
          console.log("KB No.7 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.7 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (kb["0107"].tempat_pelayanan === undefined) {
          console.log("KB No.7 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.7 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      }
    }
    //end
    // end Validasi form KB No.7

    // Validasi form KB No.8
    // harus kosong
    if (kb["0106"].jenis_kontrasepsi === "9") {
      if (kb["0108"].info_jenis_kb !== undefined) {
        console.log("KB No.8 Harus Kosong");

        newValidate = false;
        message = `KB No.8 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "1" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0108"].info_jenis_kb !== undefined) {
        console.log("KB No.8 Harus Kosong");

        newValidate = false;
        message = `KB No.8 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0108"].info_jenis_kb !== undefined) {
        console.log("KB No.8 Harus Kosong");

        newValidate = false;
        message = `KB No.8 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    //tidak boleh kosong
    if (
      kb["0106"].jenis_kontrasepsi !== "9" &&
      kb["0106"].jenis_kontrasepsi !== undefined
    ) {
      if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2" &&
        kb["0106"].jenis_kontrasepsi !== "9"
      ) {
        if (kb["0108"].info_jenis_kb === undefined) {
          console.log("KB No.8 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.8 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "1" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (kb["0108"].info_jenis_kb === undefined) {
          console.log("KB No.8 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.8 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (kb["0108"].info_jenis_kb !== undefined) {
          console.log("KB No.8 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.8 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      }
    }
    // end Validasi form KB No.8

    // Validasi form KB No.9
    //harus kosong
    if (kb["0106"].jenis_kontrasepsi === "9") {
      if (kb["0109"].pelayanan_nakes !== undefined) {
        console.log("KB No.9 Harus Kosong");

        newValidate = false;
        message = `KB No.9 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "1" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0109"].pelayanan_nakes !== undefined) {
        console.log("KB No.9 Harus Kosong");

        newValidate = false;
        message = `KB No.9 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    } else if (
      kb["0102"].sedang_hamil === "2" &&
      kb["0103"].menggunakan_kontrasepsi === "2" &&
      kb["0104"].pernah_menggunakan_kontrasepsi === "2"
    ) {
      if (kb["0109"].pelayanan_nakes !== undefined) {
        console.log("KB No.9 Harus Kosong");

        newValidate = false;
        message = `KB No.9 Harus Kosong`;
        enqueueSnackbar(message, { variant: "warning" });
      }
    }

    // //tidak boleh kosong

    // if (
    //   kb["0106"].jenis_kontrasepsi !== "9" &&
    //   kb["0106"].jenis_kontrasepsi !== undefined
    // ) {
    //   if (
    //     kb["0109"].nakes_terampil === undefined ||
    //     kb["0109"].nakes_terampil === "" ||
    //     kb["0109"].nakes_pelayanan_kebutuhan === undefined ||
    //     kb["0109"].nakes_pelayanan_kebutuhan === "" ||
    //     kb["0109"].nakes_menyampaikan_jadwal === undefined ||
    //     kb["0109"].nakes_menyampaikan_jadwal === "" ||
    //     kb["0109"].nakes_interaksi_aman_nyaman === undefined ||
    //     kb["0109"].nakes_interaksi_aman_nyaman === ""
    //   ) {
    //     newValidate = false;
    //     message = `KB No.9 Tidak Boleh Kosong`;
    //     enqueueSnackbar(message, { variant: "warning" });
    //   }
    // }
    if (
      kb["0106"].jenis_kontrasepsi !== "9" &&
      kb["0106"].jenis_kontrasepsi !== undefined
    ) {
      if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2" &&
        kb["0106"].jenis_kontrasepsi !== "9"
      ) {
        if (
          kb["0109"].nakes_terampil === undefined ||
          kb["0109"].nakes_terampil === "" ||
          kb["0109"].nakes_pelayanan_kebutuhan === undefined ||
          kb["0109"].nakes_pelayanan_kebutuhan === "" ||
          kb["0109"].nakes_menyampaikan_jadwal === undefined ||
          kb["0109"].nakes_menyampaikan_jadwal === "" ||
          kb["0109"].nakes_interaksi_aman_nyaman === undefined ||
          kb["0109"].nakes_interaksi_aman_nyaman === ""
        ) {
          console.log("KB No.9 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.9 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "1" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2" &&
        (kb["0109"].nakes_terampil === undefined ||
          kb["0109"].nakes_terampil === "" ||
          kb["0109"].nakes_pelayanan_kebutuhan === undefined ||
          kb["0109"].nakes_pelayanan_kebutuhan === "" ||
          kb["0109"].nakes_menyampaikan_jadwal === undefined ||
          kb["0109"].nakes_menyampaikan_jadwal === "" ||
          kb["0109"].nakes_interaksi_aman_nyaman === undefined ||
          kb["0109"].nakes_interaksi_aman_nyaman === "")
      ) {
        if (kb["0109"].pelayanan_nakes === undefined) {
          console.log("KB No.9 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.9 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      } else if (
        kb["0102"].sedang_hamil !== "2" &&
        kb["0103"].menggunakan_kontrasepsi !== "2" &&
        kb["0104"].pernah_menggunakan_kontrasepsi !== "2"
      ) {
        if (
          kb["0109"].nakes_terampil === undefined ||
          kb["0109"].nakes_terampil === "" ||
          kb["0109"].nakes_pelayanan_kebutuhan === undefined ||
          kb["0109"].nakes_pelayanan_kebutuhan === "" ||
          kb["0109"].nakes_menyampaikan_jadwal === undefined ||
          kb["0109"].nakes_menyampaikan_jadwal === "" ||
          kb["0109"].nakes_interaksi_aman_nyaman === undefined ||
          kb["0109"].nakes_interaksi_aman_nyaman === ""
        ) {
          console.log("KB No.9 Tidak Boleh Kosong");

          newValidate = false;
          message = `KB No.9 Tidak Boleh Kosong`;
          enqueueSnackbar(message, { variant: "warning" });
        }
      }
    }
    // end Validasi form KB No.9

    // if (newValidate == false) {
    //   enqueueSnackbar(message, { variant: "warning" });
    // }

    return newValidate;
  };

  const handleCheckSegmen = async (event) => {
    const { value } = event.target;
    const targetSegment = parseInt(value);

    if (targetSegment < 2) {
      handleSegmen(event, targetSegment);
      return;
    }
    if (targetSegment === 2) {
      const jumlahKeluarga = parseInt(wilayah.jumlah_keluarga);
      const kbIndex = 1 + jumlahKeluarga;
      handleSegmen(event, kbIndex);
      return;
    }
    if (targetSegment === 3) {
      // console.log("masuk ke segmen 3", kb["0101"]);

      if (
        !kb["0101"] ||
        kb["0101"].kelahiran === "" ||
        kb["0101"].lahir_hidup_laki_laki === "" ||
        kb["0101"].lahir_hidup_perempuan === "" ||
        kb["0101"].masih_hidup_laki_laki === "" ||
        kb["0101"].masih_hidup_perempuan === ""
      ) {
        enqueueSnackbar("Pertanyaan KB No.1 harus diisi sebelum ke PK", {
          variant: "warning",
        });
        return;
      }
      let validate = segmenValidate();
      if (validate === false) {
        return;
      }
      const x = parseInt(wilayah.jumlah_keluarga);
      let pkIndex = targetSegment;
      if (x > 1) {
        pkIndex = pkIndex + x - 1;
      }
      handleSegmen(event, pkIndex);
      return;
    }

    let validate = segmenValidate();

    if (validate === false) {
      console.log("TIDAK JALAN >>>>>>>>");
      return;
    } else {
      const { value } = event.target;
      // console.log(wilayah.status_draft, "status_draft")
      // const x = Object.keys(keluarga).length;
      const x = parseInt(wilayah.jumlah_keluarga);
      // console.log(x, 'jml kel')
      if (value) {
        let val = parseInt(value);
        // console.log(val, 'val parseint')
        if (x > 1) {
          val > 1 ? (val = val + x - 1) : (val = val);
        }

        let segment_pus = wilayah.pertanyaan_pus || "";
        if ((x === 1 && val === 2) || (segment_pus !== 1 && value === 4)) {
          console.log("masuk if kb");
          let message;
          if (val === 2) {
            message = `Data KB tidak Tersedia`;
          } else {
            message = `Data Stunting tidak Tersedia`;
          }

          enqueueSnackbar(message, { variant: "warning" });
        } else {
          // console.log("masuk jmlklg" + x + "val" + val)
          handleSegmen(event, val);
        }
      }
    }
  };

  const handleNextSub = () => {
    if (subformIndex >= 8) {
      return handleNext();
    }
    setNavigationMode("next");
    setSlide({
      direction: "right",
      in: false,
    });
    setTimeout(() => {
      setSubFormIndex((index) => index + 1);
      setSlide({
        direction: "left",
        in: true,
      });
    }, 300);
  };

  const handleBackSub = () => {
    if (subformIndex === 0) {
      return handleBack();
    }

    setNavigationMode("back");
    setSlide({
      direction: "left",
      in: false,
    });
    setTimeout(() => {
      setSubFormIndex((index) => index - 1);
      setSlide({
        direction: "right",
        in: true,
      });
    }, 300);
  };

  //console.log("subformIndex nya neeh : ", subformIndex)
  const no = Object.keys(subforms)[subformIndex];

  const setValue = (e) => {
    if (e.target.name === "kelahiran" && e.target.value === "0") {
      const inputan = [
        "kelahiran",
        "lahir_hidup_laki_laki",
        "lahir_hidup_perempuan",
        "masih_hidup_laki_laki",
        "masih_hidup_perempuan",
      ];
      for (let i = 0; i < inputan.length; i++) {
        setKB((kb) => ({
          ...kb,
          [no]: {
            ...kb[no],
            [inputan[i]]: "0",
          },
        }));
        setSomethingChange(true);
      }

      // } else if (e.target.name == "pernah_menggunakan_kontrasepsi" && e.target.value === "2") {
      //     const inputankb5 = ["pernah_menggunakan_kontrasepsi",
      //         "bulan_mulai",
      //         "tahun_mulai",
      //         "bulan_berhenti",
      //         "tahun_berhenti"]
      //     for (let i = 0; i < inputankb5.length; i++) {

      //         setKB((kb) => ({
      //             ...kb,
      //             [no]: {
      //                 ...kb[no],
      //                 [inputankb5[i]]: "",
      //                 [inputankb5["pernah_menggunakan_kontrasepsi"]]: "2"
      //             }
      //         }))
      //         setSomethingChange(true)
      //     }
    } else if (e.target.name === "kelahiran" && e.target.value === "") {
      const inputan = [
        "kelahiran",
        "lahir_hidup_laki_laki",
        "lahir_hidup_perempuan",
        "masih_hidup_laki_laki",
        "masih_hidup_perempuan",
      ];
      for (let i = 0; i < inputan.length; i++) {
        setKB((kb) => ({
          ...kb,
          [no]: {
            ...kb[no],
            [inputan[i]]: "",
          },
        }));
        setSomethingChange(true);
      }
    } else {
      setKB({
        ...kb,
        [no]: {
          ...kb[no],
          [e.target.name]: e.target.value,
        },
      });
      setSomethingChange(true);
    }
  };

  const saveValue = (normalizeValue) => {
    let period = "2025";
    if (mode === "edit") {
      period = wilayah.periode_sensus;
    }

    if (!isSomethingChange) {
      setNormalizeKB((normalizeKB) => ({
        ...normalizeKB,
        [no]: {
          ...normalizeValue,
          periode_sensus: period,
          user_name: metadata.name,
        },
      }));
      return handleNextSub();
    }
    //simpan ke db local
    setSubmitting(true);
    //const id = `${wilayah.no_kk}${no}`;
    try {
      // const existing = await dataKB.local.get(id)

      // await dataKB.local.put({
      //     _id: id,
      //     _rev: existing._rev,
      //     ...normalizeValue
      // })
      setNormalizeKB((normalizeKB) => ({
        ...normalizeKB,
        [no]: {
          ...normalizeValue,
          periode_sensus: period,
          user_name: metadata.name,
        },
      }));

      setSomethingChange(false);
      setSubmitting(false);
      handleNextSub();
    } catch (e) {
      setSubmitting(false);
      if (e.name === "not_found") {
        try {
          // await dataKB.local.put({
          //     _id: id,
          //     type: 'anggota',
          //     ...normalizeValue
          // })

          setSomethingChange(false);
          handleNextSub();
        } catch (e) {
          enqueueSnackbar(e.message, { variant: "error" });
        }
      } else {
        enqueueSnackbar(e.message, { variant: "error" });
      }
    }
  };

  const saveValueJump = (normalizeValue) => {
    if (!isSomethingChange) {
      setNormalizeKB((normalizeKB) => ({
        ...normalizeKB,
        [no]: {
          ...normalizeValue,
        },
      }));
    }
    //simpan ke db local
    setSubmitting(true);
    //const id = `${wilayah.no_kk}${no}`;
    try {
      // const existing = await dataKB.local.get(id)

      // await dataKB.local.put({
      //     _id: id,
      //     _rev: existing._rev,
      //     ...normalizeValue
      // })
      setNormalizeKB((normalizeKB) => ({
        ...normalizeKB,
        [no]: {
          ...normalizeValue,
        },
      }));

      setSomethingChange(false);
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      if (e.name === "not_found") {
        try {
          // await dataKB.local.put({
          //     _id: id,
          //     type: 'anggota',
          //     ...normalizeValue
          // })

          setSomethingChange(false);
        } catch (e) {
          enqueueSnackbar(e.message, { variant: "error" });
        }
      } else {
        enqueueSnackbar(e.message, { variant: "error" });
      }
    }
  };

  //console.log("Index KB nya : ", wilayah.pos_draft)

  // subform aktif
  const { component: SubForm } = subforms[no];
  const value = kb[no];

  //console.log("VALUE INDEX KB : ", value)
  //console.log("no => ", no)
  // console.log(value, kb, "value kb");

  return (
    <>
      <Swipeable
        trackMouse={true}
        onSwipedRight={(e) => {
          try {
            if (backRef) {
              backRef.current.click();
            }
          } catch (e) {
            // enqueueSnackbar(e.message, { variant: 'error' })
          }
        }}
        onSwipedLeft={(e) => {
          try {
            if (nextRef) {
              nextRef.current.click();
            }
          } catch (e) {
            // enqueueSnackbar(e.message, { variant: 'error' })
          }
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.textCenter}>
            <Typography variant="h5" component="h1">
              {mode === "edit"
                ? `Edit Form Keluarga Berencana`
                : "Form Keluarga Berencana"}
            </Typography>
            {/* {mode === 'edit' && <Typography>No KK: {no_kk}</Typography>} */}
          </Grid>

          <Grid item xs className={classes.textLeft}>
            {(mode === "edit" &&
              wilayah.status_draft &&
              wilayah.status_draft === "1") ||
            (Object.hasOwn(wilayah, "submit") && wilayah.submit === false) ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 2, subformIndex)}
                  disabled={isSubmitting.local || isSaved.local}
                  style={{ marginRight: "10px" }}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}

            {mode === "edit" &&
            (wilayah.status_draft === undefined ||
              wilayah.status_draft === "2") ? (
              <>
                <FormControl variant="outlined">
                  <Select
                    id=""
                    value=""
                    name="segmen"
                    onChange={handleCheckSegmen}
                    displayEmpty
                  >
                    <MenuItem value=""> Segmen </MenuItem>
                    <MenuItem value="0"> Wilayah </MenuItem>
                    <MenuItem value="1"> Keluarga </MenuItem>
                    <MenuItem value="2"> KB </MenuItem>
                    <MenuItem value="3"> PK </MenuItem>
                    {/* <MenuItem value="4"> Stunting </MenuItem> */}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}

            {mode !== "edit" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDraft("local", 2, subformIndex)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <SaveIcon className={classes.iconLeft} /> Save as Draft{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item>
            {mode === "edit" && wilayah.status_sensus === "Anomali" ? (
              <>
                {" "}
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleAnomali("local", 1)}
                  disabled={isSubmitting.local || isSaved.local}
                >
                  <AssignmentTurnedInIcon /> Anomali Terkonfirmasi{" "}
                </Button>{" "}
              </>
            ) : (
              <></>
            )}
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Slide direction={slide.direction} in={slide.in}>
              <div className={classes.slideContent}>
                {value && (
                  <SubForm
                    id={no}
                    no_kk={wilayah.no_kk}
                    value={value}
                    setValue={setValue}
                    saveValue={saveValue}
                    saveValueJump={saveValueJump}
                    keluarga={keluarga}
                    kb={kb}
                    setKB={setKB}
                    handleNextSub={handleNextSub}
                    handleBackSub={handleBackSub}
                    navigationMode={navigationMode}
                    isSubmitting={isSubmitting}
                  />
                )}
              </div>
            </Slide>
          </Grid>
          {/* <Grid item xs>
                    <Button
                        ref={backRef}
                        // disabled={!isSomethingChange || isSubmitting}
                        onClick={handleBackSub}><ChevronLeft className={classes.iconLeft} /> Sebelumnya </Button>
                </Grid> */}

          {/* <Grid item xs>
                    {
                        mode === "edit" && wilayah.status_draft && wilayah.status_draft === '1' ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 2, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }

                    {
                        mode == "edit" && (wilayah.status_draft == undefined || wilayah.status_draft == '2') ?
                            <>
                                <FormControl
                                    variant="outlined">
                                    <Select
                                        id=""
                                        value=""
                                        name="segmen"
                                        onChange={handleCheckSegmen}
                                        displayEmpty
                                    >
                                        <MenuItem value=""> Segmen </MenuItem>
                                        <MenuItem value="0"> Wilayah </MenuItem>
                                        <MenuItem value="1"> Keluarga </MenuItem>
                                        <MenuItem value="2"> KB </MenuItem>
                                        <MenuItem value="3"> PK </MenuItem>
                                    </Select>
                                </FormControl>
                            </> : <></>
                    }

                    {
                        mode !== "edit" ?
                            <> <Button
                                color="primary"
                                variant="contained"
                                onClick={handleDraft('local', 2, subformIndex)}
                                disabled={isSubmitting.local || isSaved.local}
                            >
                                <SaveIcon className={classes.iconLeft} /> Save as Draft </Button> </> : <></>
                    }
                </Grid> */}

          {/* <Grid item>
                    {isSubmitting && <CircularProgress size={14} />}
                    <Button
                        ref={nextRef}
                        form={no}
                        disabled={isSubmitting}
                        type="submit">Selanjutnya <ChevronRight className={classes.iconRight} /></Button>
                </Grid> */}
        </Grid>
      </Swipeable>
    </>
  );
}

export default KB;
